import { render, staticRenderFns } from "./NewStatutoryBasis.vue?vue&type=template&id=5ddadb94&scoped=true"
import script from "./NewStatutoryBasis.vue?vue&type=script&lang=js"
export * from "./NewStatutoryBasis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddadb94",
  null
  
)

export default component.exports